<template>
    <v-container fluid class="pa-0">
        <v-tabs v-model="tab" class="mt-2 px-4">
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-me" class="text-none font-weight-bold">
                <v-icon left small>mdi-calendar-account</v-icon>
                My Calendar
            </v-tab>
            <v-tab v-if="calendarTabs.businessUnit" href="#tab-company" class="text-none font-weight-bold">
                <v-icon left small>mdi-domain</v-icon>
                Business Unit Calendar
            </v-tab>
            <v-tab v-if="calendarTabs.team" href="#tab-team" class="text-none font-weight-bold">
                <v-icon left small>mdi-account-group</v-icon>
                Team Calendar
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="tab-me">
                <MyCalendarComponent />
            </v-tab-item>
            <v-tab-item v-if="calendarTabs.businessUnit" value="tab-company">
                <v-card flat class="pa-4">
                    <TeamCalendarPanel scope="company" />
                </v-card>
            </v-tab-item>
            <v-tab-item v-if="calendarTabs.team" value="tab-team">
                <v-card flat class="pa-4">
                    <TeamCalendarPanel scope="team" />
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import MyCalendarComponent from './MyCalendarComponent.vue';
import TeamCalendarPanel from '@/components/leave-management/TeamCalendarPanel.vue';
import { calendarTabAccess } from '@/components/leave-management/leaveUtils';

// One Calendar page: everyone gets "My Calendar"; Super Admin, company managers and
// team managers also get the Business Unit / Team calendars (same rules as the API).
export default {
    name: 'CalendarHubComponent',
    components: { MyCalendarComponent, TeamCalendarPanel },
    inject: { users: { default: null }, roleManagers: { default: null } },
    data() {
        return { tab: null };
    },
    computed: {
        ...mapGetters({ user: 'auth/get_user' }),
        calendarTabs() {
            const list = (this.users && this.users()) || [];
            const rows = (this.roleManagers && this.roleManagers()) || [];
            return calendarTabAccess(this.user, list, rows);
        },
    },
};
</script>
